module.exports = __webpack_public_path__ + "static/img/goal-09.83ac781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/community/goal-09.png
// module id = Q7FP
// module chunks = 2